import store from "../store";
import { countryColorList } from "../lib/countryList";
import moment from "moment-timezone";
import { toTitleCase } from "../components/MainContent/Dashboard/Charts/utils";

export function formatData(data) {
    const chart_name = data?.chart_name;
    const resp_data = data?.response;
    const isAverage = data?.isAverage;
    // console.log(data);
    if (Object.keys(resp_data).length === 0) {
        return resp_data;
    }
    if (chart_name === "audience_metrics_by_age") {
        let obj = resp_data;
        let malesLabel = ["m.13-17", "m.18-24", "m.25-34", "m.35-44", "m.45-54", "m.55-64", "m.65+"];
        let femalesLabel = ["f.13-17", "f.18-24", "f.25-34", "f.35-44", "f.45-54", "f.55-64", "f.65+"];
        let othersLabel = ["u.13-17", "u.18-24", "u.25-34", "u.35-44", "u.45-54", "u.55-64", "u.65+"];
        let hashMap = obj;
        let males = [];
        let females = [];
        let others = [];
        malesLabel.forEach((ele) => {
            let count = 0;
            let data = hashMap[ele];
            if (data) {
                data.forEach((ele) => {
                    count += ele.count;
                });
                males.push(count);
            } else males.push(count);
        });
        femalesLabel.forEach((ele) => {
            let count = 0;
            let data = hashMap[ele];
            if (data) {
                data.forEach((ele) => {
                    count += ele.count;
                });
                females.push(count);
            } else females.push(count);
        });
        othersLabel.forEach((ele) => {
            let count = 0;
            let data = hashMap[ele];
            if (data) {
                data.forEach((ele) => {
                    count += ele.count;
                });
                others.push(count);
            } else others.push(count);
        });
        let malesCount = males.reduce((x, y) => x + y, 0);
        let femalesCount = females.reduce((x, y) => x + y, 0);
        let otherCount = others.reduce((x, y) => x + y, 0);
        let totalCount = malesCount + femalesCount + otherCount;
        let pieChartData = [
            { name: "13-17", y: males[0] + females[0] + others[0] },
            { name: "18-24", y: males[1] + females[1] + others[1] },
            { name: "25-34", y: males[2] + females[2] + others[2] },
            { name: "35-44", y: males[3] + females[3] + others[3] },
            { name: "45-54", y: males[4] + females[4] + others[4] },
            { name: "55-64", y: males[5] + females[5] + others[5] },
            { name: "65+", y: males[6] + females[6] + others[6] },
        ];
        let barChartData = [
            { name: "13-17", data: [{ name: "13-17", y: males[0] + females[0] + others[0], total: totalCount }] },
            { name: "18-24", data: [{ name: "18-24", y: males[1] + females[1] + others[1], total: totalCount }] },
            { name: "25-34", data: [{ name: "25-34", y: males[2] + females[2] + others[2], total: totalCount }] },
            { name: "35-44", data: [{ name: "35-44", y: males[3] + females[3] + others[3], total: totalCount }] },
            { name: "45-54", data: [{ name: "45-54", y: males[4] + females[4] + others[4], total: totalCount }] },
            { name: "55-64", data: [{ name: "55-64", y: males[5] + females[5] + others[5], total: totalCount }] },
            { name: "65+", data: [{ name: "65+", y: males[6] + females[6] + others[6], total: totalCount }] },
        ];
        barChartData = barChartData.sort((a, b) => {
            if (a.data[0].y > b.data[0].y) {
                return -1;
            }
            if (a.data[0].y < b.data[0].y) {
                return 1;
            } else return 0;
        });
        let labels = barChartData.map((ele) => ele.name);
        return { barChartData: barChartData, pieChartData: pieChartData, labels: labels };
    }
    if (chart_name === "audience_metrics_by_gender") {
        let obj = resp_data;
        let malesLabel = ["m.13-17", "m.18-24", "m.25-34", "m.35-44", "m.45-54", "m.55-64", "m.65+"];
        let femalesLabel = ["f.13-17", "f.18-24", "f.25-34", "f.35-44", "f.45-54", "f.55-64", "f.65+"];
        let othersLabel = ["u.13-17", "u.18-24", "u.25-34", "u.35-44", "u.45-54", "u.55-64", "u.65+"];
        let hashMap = obj;
        let males = [];
        let females = [];
        let others = [];

        malesLabel.forEach((ele) => {
            let count = 0;
            let data = hashMap[ele];
            if (data) {
                data.forEach((ele) => {
                    count += ele.count;
                });
                males.push(count);
            } else males.push(count);
        });
        femalesLabel.forEach((ele) => {
            let count = 0;
            let data = hashMap[ele];
            if (data) {
                data.forEach((ele) => {
                    count += ele.count;
                });
                females.push(count);
            } else females.push(count);
        });
        othersLabel.forEach((ele) => {
            let count = 0;
            let data = hashMap[ele];
            if (data) {
                data.forEach((ele) => {
                    count += ele.count;
                });
                others.push(count);
            } else others.push(count);
        });
        let malesCount = males.reduce((x, y) => x + y, 0);
        let femalesCount = females.reduce((x, y) => x + y, 0);
        let othersCount = others.reduce((x, y) => x + y, 0);
        let totalVal = malesCount + femalesCount + othersCount;
        let pieChartData = [
            { name: "Male", y: malesCount, color: "#6CB4EE" },
            { name: "Female", y: femalesCount, color: "#FFAEBC" },
            { name: "Others", y: othersCount, color: "#A0E7E5" },
        ];
        let barChartData = [
            { name: "Male", count: malesCount, data: [{ name: "Male", y: malesCount, color: "#6CB4EE", total: totalVal }], color: "#6CB4EE" },
            { name: "Female", count: femalesCount, data: [{ name: "Female", y: femalesCount, color: "#FFAEBC", total: totalVal }], color: "#FFAEBC" },
            { name: "Others", count: othersCount, data: [{ name: "Others", y: othersCount, color: "#A0E7E5", total: totalVal }], color: "#A0E7E5" },
        ];
        let sortedbarChartData = barChartData.sort((a, b) => b.count - a.count);
        return { barChartData: sortedbarChartData, pieChartData: pieChartData, total: totalVal };
    }
    if (chart_name === "audience_metrics_by_country") {
        let barChartData = [];
        let pieChartData = [];
        let LocationWithData = [];
        let countryData = resp_data || {};
        const masterLocationList = countryColorList;
        let LocationKeys = [];
        let hashMap = [];
        for (const key in countryData) {
            let count = 0;
            countryData[key].forEach((ele) => {
                count += ele.count;
            });
            hashMap.push({ name: key, count: count });
            LocationKeys.push(key);
        }

        let locationHashMap = {};
        LocationKeys.forEach((short_name) => {
            let country = masterLocationList.find((ele) => ele.code.toLowerCase() == short_name);
            if (country) {
                locationHashMap[short_name] = country.country;
            }
        });
        let sortedHashMap = hashMap.sort((a, b) => {
            if (a.count > b.count) {
                return -1;
            } else return 1;
        });
        let totalCount = sortedHashMap.reduce((acc, curr) => {
            return acc + curr.count;
        }, 0);
        sortedHashMap.forEach((ele, ind) => {
            if (ind < 9) {
                let obj = {};
                obj["name"] = locationHashMap[ele.name];
                obj["data"] = [];
                let dataObj = {};
                dataObj["name"] = locationHashMap[ele.name];
                dataObj["y"] = ele.count;
                dataObj["total"] = totalCount;
                obj["data"].push(dataObj);
                barChartData.push(obj);
                pieChartData.push({ name: locationHashMap[ele.name], y: ele.count });
                LocationWithData.push(locationHashMap[ele.name]);
            }
        });
        if (sortedHashMap.length > 9) {
            let count = 0;
            sortedHashMap.forEach((ele, ind) => {
                if (ind > 8) {
                    count += ele.count;
                }
            });
            if (count > 0) {
                let obj = {};
                obj["name"] = "Others";
                obj["data"] = [];
                let dataObj = {};
                dataObj["name"] = "Others";
                dataObj["y"] = count;
                dataObj["total"] = totalCount;
                obj["data"].push(dataObj);
                pieChartData.push({ name: "Others", y: count });
                barChartData.push(obj);
                LocationWithData.push("Others");
            }
        }
        barChartData = barChartData.sort((a, b) => {
            if (a.data[0].y > b.data[0].y) {
                return 1;
            }
            if (a.data[0].y < b.data[0].y) {
                return -1;
            } else return 0;
        });
        return {
            barChartData: barChartData,
            pieChartData: pieChartData,
            LocationWithData: LocationWithData,
            downLoadData: sortedHashMap,
            allLocation: locationHashMap,
        };
    }
    if (chart_name === "audience_metrics_by_city") {
        let barChartData = [];
        let pieChartData = [];
        let cityLevelData = resp_data;
        let hashMap = [];
        let cityLocationWithData = [];
        for (const key in cityLevelData) {
            let count = 0;
            cityLevelData[key].forEach((ele) => {
                count += ele.count;
            });
            hashMap.push({ name: key, count: count });
        }
        let sortedHashMap = hashMap.sort((a, b) => {
            if (a.count > b.count) {
                return -1;
            } else 1;
        });
        let totalCount = sortedHashMap.reduce((acc, curr) => {
            return acc + curr.count;
        }, 0);
        sortedHashMap.forEach((ele, ind) => {
            if (ind < 9) {
                let obj = {};
                obj["name"] = ele.name;
                obj["data"] = [];
                let dataObj = {};
                dataObj["name"] = ele.name;
                dataObj["y"] = ele.count;
                dataObj["total"] = totalCount;
                obj["data"].push(dataObj);
                barChartData.push(obj);
                cityLocationWithData.push(ele.name);
                pieChartData.push({ name: ele.name, y: ele.count });
            }
        });
        if (sortedHashMap.length > 9) {
            let count = 0;
            sortedHashMap.forEach((ele, ind) => {
                if (ind > 8) {
                    count += ele.count;
                }
            });
            if (count > 0) {
                let obj = {};
                obj["name"] = "Others";
                obj["data"] = [];
                let dataObj = {};
                dataObj["name"] = "Others";
                dataObj["y"] = count;
                dataObj["total"] = totalCount;
                obj["data"].push(dataObj);
                barChartData.push(obj);
                cityLocationWithData.push("Others");
                pieChartData.push({ name: "Others", y: count });
            }
        }
        let cbarChartData = barChartData.sort((a, b) => {
            if (a.data[0].y > b.data[0].y) {
                return 1;
            }
            if (a.data[0].y < b.data[0].y) {
                return -1;
            } else return 0;
        });
        return { barChartData: cbarChartData, pieChartData: pieChartData, cityLocationWithData: cityLocationWithData, downLoadData: sortedHashMap };
    }
    if (chart_name === "insta_page_follower_change") {
        let data = resp_data?.follower_info?.buckets || [];
        let lineChartData = data.map((ele) => {
            return { x: +moment(ele.date).format("x"), y: ele.followersCount };
        });
        let barChartData = [];
        return { lineChartData: lineChartData };
    }
    if (chart_name === "insta_page_profile_views") {
        let data = resp_data?.total || [];
        let lineChartData = data.map((ele) => {
            return { x: +moment(ele.key_as_string).format("x"), y: ele.count };
        });
        return { lineChartData: lineChartData };
    }

    if ((chart_name === "engagement_by_bookmark" || chart_name === "engagement_by_video") && !isAverage) {
        // console.log("hello", resp_data);
        let data = resp_data?.total || [];
        let lineChartData = data.map((ele) => {
            return { x: +moment(ele.key_as_string).format("x"), y: ele.count };
        });
        return { lineChartData: lineChartData };
    }

    if (chart_name === "IgRecentPosts" || chart_name === "IgRecentStories") {
        let recentPosts = [];
        let data;
        data = resp_data.filter((item) => item?._source?.post?.post_subtype !== "ads");
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        data?.forEach((item) => {
            let image_url = "https://2020assets.s3.amazonaws.com/images/" + item?._source?.post?.media[0].folder + "/" + item?._source?.post?.media[0].name;
            let profile_pic =
                "https://2020assets.s3.amazonaws.com/images/" + item?._source?.post_author?.media[0].folder + "/" + item?._source?.post_author?.media[0].name;
            let totalEngagement =
                item?._source.post?.engagement_values?.like_count +
                item?._source.post?.engagement_values?.comment_count +
                item?._source.post?.engagement_values?.share_count;
            // + item?._source.post?.engagement_values?.share_count +
            // item?._source.post?.engagement_values?.view_count;
            if (item) {
                recentPosts.push({
                    gender: item?._source?.post_author?.gender,
                    profile_pic: profile_pic,
                    username: item._source?.post_author?.username ?? item?._source?.handlers[0].value,
                    post_type: item?._source?.post?.media[0].type,
                    image_url: image_url,
                    content: item?._source?.post?.content,
                    title: item?._source?.post?.title,
                    post_url: item?._source?.post?.url,
                    created_date: moment(item?._source?.post?.published_date).tz(tz).format("DD MMM YYYY"),
                    hover_date: moment(item?._source?.post?.published_date).tz(tz).format("LLLL z"),
                    engagement: item?._source?.post?.engagement_values,
                    impact: item?._source.impact_value,
                    totalEngagement: totalEngagement,
                });
            }
        });

        if (chart_name !== "IgRecentStories") recentPosts = recentPosts.filter((post) => !post?.post_url?.includes("stories"));

        recentPosts = recentPosts.slice(0, 10);
        // recentPosts.sort(function (a, b) {
        //     return parseFloat(b.totalEngagement) - parseFloat(a.totalEngagement);
        // });

        return recentPosts;
    }

    if (chart_name === "insta_posts_overtime" || chart_name === "insta_story_overtime") {
        let data = { nodata: resp_data.hits.total === 0, lineChartData: [] };
        let total = 0;
        let tz = JSON.parse(localStorage.company).user_timezone_name;

        data.lineChartData = resp_data.aggregations.conversation_over_time.buckets.map((d) => {
            total += d.doc_count;
            let date = +moment(d.key).tz(tz).format("x");
            return [date, d.doc_count];
        });

        data.nodata = total === 0;

        return data;
    }

    if (chart_name === "engagement_over_time") {
        // console.log(resp_data);

        let obj = {
            nodata: resp_data.hits.total === 0,
            total_agg: [],
            avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;

        let total_agg = {};
        let total = 0;

        resp_data.aggregations.likes_datewise_breakdown.buckets.forEach((likes) => {
            let d = +moment(likes.key).tz(tz).format("x");

            total_agg[d] = likes.data_stats.sum;
            total += likes.data_stats.sum;
        });

        resp_data.aggregations.comments_datewise_breakdown.buckets.forEach((comments) => {
            let d = +moment(comments.key).tz(tz).format("x");
            total_agg[d] += comments.data_stats.sum;
            total += comments.data_stats.sum;
        });

        resp_data.aggregations.shares_datewise_breakdown.buckets.forEach((shares) => {
            let d = +moment(shares.key).tz(tz).format("x");
            total_agg[d] += shares.data_stats.sum;
            total += shares.data_stats.sum;
        });

        // resp_data.aggregations.view_datewise_breakdown.buckets.forEach((views) => {
        //     let d = +moment(views.key).tz(tz).format("x");

        //     total_agg[d] = views.data_stats.sum;
        //     total += views.data_stats.sum;
        // });

        obj.total_agg = Object.entries(total_agg).map(([k, v]) => [+k, v || 0]);

        let totallength = resp_data.hits.total || 1;

        obj.avg_value = +(total / totallength).toFixed(2);

        return obj;
    }

    if (chart_name === "engagement_rate_over_time") {
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        const engagementData = resp_data.find((obj) => obj.name === "engagementOverTime");
        const { data: followersData } = resp_data.find((obj) => obj.name === "followersOverTime");
        // console.log("followersData", followersData?.follower_info?.buckets);

        let obj = {
            nodata: false,
            total_agg: [],
            avg_value: 0,
        };

        const total_agg = {};
        const followerData = {};
        let total = 0;
        let totalVal = 0;

        engagementData?.data?.aggregations.likes_datewise_breakdown.buckets.forEach((likes) => {
            let d = +moment(likes.key).tz(tz).format("x");

            total_agg[d] = likes.data_stats.sum;
            total += likes.data_stats.sum;
        });

        engagementData?.data?.aggregations.comments_datewise_breakdown.buckets.forEach((comments) => {
            let d = +moment(comments.key).tz(tz).format("x");
            total_agg[d] += comments.data_stats.sum;
            total += comments.data_stats.sum;
        });

        engagementData?.data?.aggregations.shares_datewise_breakdown.buckets.forEach((shares) => {
            let d = +moment(shares.key).tz(tz).format("x");
            total_agg[d] += shares.data_stats.sum;
            total += shares.data_stats.sum;
        });

        const engagmentList = Object.values(total_agg);
        console.log("total_agg", engagmentList);
        followersData?.follower_info?.buckets?.forEach((followersObj, ind) => {
            const date = +moment(followersObj.date).tz(tz).format("x");

            // console.log("foll", date, total_agg[date]);
            if (engagmentList[ind] && followersObj?.followersCount !== 0) {
                followerData[date] = +(engagmentList[ind] / followersObj?.followersCount || 0).toFixed(4);
                totalVal += followerData[date];
            } else {
                // console.log("not present");
                followerData[date] = 0;
            }
        });

        obj.total_agg = Object.entries(followerData).map(([k, v]) => [+k, v || 0]);
        obj.nodata = engagementData?.data?.hits.total === 0 || totalVal === 0;

        return obj;
    }

    if (chart_name === "engagement_by_reach") {
        let obj = {
            nodata: resp_data.hits.total === 0,
            views_agg: [],
            views_avg: [],
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;

        resp_data.aggregations.view_datewise_breakdown.buckets.forEach((views) => {
            let d = +moment(views.key).tz(tz).format("x");
            obj.views_agg.push([d, views.data_stats.sum || 0]);
            obj.views_avg.push([d, views.data_stats.avg || 0]);
        });

        return obj;
    }
    if (chart_name === "insta_post_reach") {
        // console.log(resp_data);

        let obj = {
            nodata: resp_data.hits.total === 0,
            views_agg: [],
            avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let total = 0;

        resp_data.aggregations.reach_datewise_breakdown.buckets.forEach((views) => {
            let d = +moment(views.key).tz(tz).format("x");
            obj.views_agg.push([d, views.data_stats.sum || 0]);

            total += views.data_stats.sum;
        });

        let totallength = resp_data.hits.total || 1;

        obj.avg_value = +(total / totallength).toFixed(2);

        return obj;
    }
    if (chart_name === "engagement_by_impressions") {
        // console.log(resp_data);

        let obj = {
            nodata: resp_data.hits.total === 0,
            impression_agg: [],
            impression_avg: [],
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;

        resp_data.aggregations.impressions_datewise_breakdown.buckets.forEach((views) => {
            let d = +moment(views.key).tz(tz).format("x");
            obj.impression_agg.push([d, views.data_stats.sum || 0]);
            obj.impression_avg.push([d, views.data_stats.avg || 0]);
        });

        return obj;
    }
    if (chart_name === "insta_post_impressions") {
        let obj = {
            nodata: resp_data.hits.total === 0,
            impression_agg: [],
            avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let total = 0;
        resp_data.aggregations.impressions_datewise_breakdown.buckets.forEach((views) => {
            let d = +moment(views.key).tz(tz).format("x");
            obj.impression_agg.push([d, views.data_stats.sum || 0]);
            total += views.data_stats.sum;
        });

        let totallength = resp_data.hits.total || 1;

        obj.avg_value = +(total / totallength).toFixed(2);

        return obj;
    }
    if (chart_name === "insta_post_likes") {
        let obj = {
            nodata: resp_data.hits.total === 0,
            likes_agg: [],
            avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let total = 0;

        resp_data.aggregations?.likes_datewise_breakdown?.buckets.forEach((likes) => {
            let d = +moment(likes.key).tz(tz).format("x");
            obj.likes_agg.push([d, likes.data_stats.sum || 0]);

            total += likes.data_stats.sum;
        });

        let totallength = resp_data.hits.total || 1;

        obj.avg_value = +(total / totallength).toFixed(2);

        return obj;
    }
    if (chart_name === "insta_post_comments") {
        let obj = {
            nodata: resp_data.hits.total === 0,
            comments_agg: [],
            avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let total = 0;

        resp_data.aggregations?.comments_datewise_breakdown?.buckets.forEach((comments) => {
            let d = +moment(comments.key).tz(tz).format("x");
            obj.comments_agg.push([d, comments.data_stats.sum || 0]);

            total += comments.data_stats.sum;
        });

        let totallength = resp_data.hits.total || 1;

        obj.avg_value = +(total / totallength).toFixed(2);

        return obj;
    }
    if (chart_name === "insta_story") {
        let obj = {
            nodata: resp_data.hits.total === 0,
            views_agg: [],
            exits_agg: [],
            avg_views_value: 0,
            avg_exits_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let totalExits = 0;
        let totalViews = 0;

        resp_data.aggregations?.exits_datewise_breakdown?.buckets.forEach((exits) => {
            let d = +moment(exits.key).tz(tz).format("x");
            obj.exits_agg.push([d, exits.data_stats.sum || 0]);

            totalExits += exits.data_stats.sum;
        });

        resp_data.aggregations?.view_datewise_breakdown?.buckets.forEach((views) => {
            let d = +moment(views.key).tz(tz).format("x");
            obj.views_agg.push([d, views.data_stats.sum || 0]);

            totalViews += views.data_stats.sum;
        });

        let totallength = resp_data.hits.total || 1;

        obj.avg_exits_value = +(totalExits / totallength).toFixed(2);
        obj.avg_views_value = +(totalViews / totallength).toFixed(2);

        return obj;
    }

    if (chart_name === "insta_story_replies") {
        let obj = {
            nodata: resp_data.hits.total === 0,
            comments_agg: [],
            avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let total = 0;

        resp_data.aggregations?.comments_datewise_breakdown?.buckets.forEach((comments) => {
            let d = +moment(comments.key).tz(tz).format("x");
            obj.comments_agg.push([d, comments.data_stats.sum || 0]);

            total += comments.data_stats.sum;
        });

        let totallength = resp_data.hits.total || 1;

        obj.avg_value = +(total / totallength).toFixed(2);

        return obj;
    }
    if (chart_name === "insta_story_by_reach") {
        let obj = {
            nodata: resp_data.hits.total === 0,
            views_agg: [],
            avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let total = 0;

        resp_data.aggregations?.view_datewise_breakdown?.buckets.forEach((views) => {
            let d = +moment(views.key).tz(tz).format("x");
            obj.views_agg.push([d, views.data_stats.sum || 0]);

            total += views.data_stats.sum;
        });

        let totallength = resp_data.hits.total || 1;

        obj.avg_value = +(total / totallength).toFixed(2);

        return obj;
    }
    if (chart_name === "insta_story_by_taps") {
        let obj = {
            nodata: resp_data.hits.total === 0,
            forward_agg: [],
            backward_agg: [],
            // avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;
        // let total = 0;

        resp_data.aggregations?.taps_forwards_datewise_breakdown?.buckets.forEach((taps) => {
            let d = +moment(taps.key).tz(tz).format("x");
            obj.forward_agg.push([d, taps.data_stats.sum || 0]);
        });
        resp_data.aggregations?.taps_backwards_datewise_breakdown?.buckets.forEach((taps) => {
            let d = +moment(taps.key).tz(tz).format("x");
            obj.backward_agg.push([d, taps.data_stats.sum || 0]);
        });

        return obj;
    }
    if (chart_name === "total_reach") {
        let reach1 = resp_data.find((r) => r.name === "reach1");
        let reach2 = resp_data.find((r) => r.name === "reach2");

        let obj = {
            reach1: null,
            reach2: null,
            nodata: false,
            avg_reach: null,
            reach_percentage_change: null,
            durationGap: +data.durationGap.toFixed(0),
        };

        obj.nodata = reach1.data?.hits.total == 0;

        obj.reach1 = reach1.data?.aggregations?.reach_datewise_breakdown?.buckets?.reduce((acc, val) => acc + val.data_stats.sum, 0);
        obj.reach2 = reach2.data?.aggregations?.reach_datewise_breakdown?.buckets?.reduce((acc, val) => acc + val.data_stats.sum, 0);

        if ((obj.reach1 && !(obj.reach1 > 0)) || obj.reach1 === 0 || (obj.reach1 === 0 && obj.reach1 === 0)) obj.nodata = true;

        if (!obj.nodata) {
            obj.avg_reach = +(obj.reach1 / reach1.data?.hits.total).toFixed(2);
            if (obj.reach2 !== 0) obj.reach_percentage_change = +(((obj.reach1 - obj.reach2) / obj.reach2) * 100).toFixed(2);
        }
        return obj;
    }
    if (chart_name === "insta_story_media_breakup") {
        let obj = {
            nodata: false,
            data: [],
            total: 0,
        };

        if (resp_data?.hits.total == 0) obj.nodata = true;
        else {
            obj.total = resp_data?.hits.total;
            resp_data?.aggregations?.post_media_breakup?.buckets.forEach((b) => {
                obj.data.push({
                    // color: getSentimentColor(x[0]),
                    name: toTitleCase(b.key),
                    y: +((b.doc_count / resp_data?.hits.total) * 100).toFixed(2),
                    doc_count: b.doc_count,
                });
            });
        }

        return obj;
    }

    if (
        chart_name === "total_engagement" ||
        chart_name === "total-page-views" ||
        chart_name === "total-posts" ||
        chart_name === "total-posts-likes" ||
        chart_name === "total-posts-comments" ||
        chart_name === "total-posts-impressions" ||
        chart_name === "total-stories" ||
        chart_name == "total-stories-engagements"
    ) {
        let { data: presentDurationData } = resp_data.find((r) => r.name === "presentDurationData");
        // let { data: presentDurationData } = resp_data.find((r) => r.value.name === "presentDurationData").value;
        let { data: previousDurationData } = resp_data.find((r) => r.name === "previousDurationData");

        let obj = {
            presentDurationData: null,
            previousDurationData: null,
            nodata: false,
            percentage_change: null,
            durationGap: +data.durationGap.toFixed(0),
        };

        switch (chart_name) {
            case "total_engagement":
                obj.nodata = presentDurationData?.hits?.total == 0;
                obj.presentDurationData =
                    presentDurationData?.aggregations?.likes_datewise_breakdown?.buckets?.reduce((acc, val) => acc + val.data_stats?.sum, 0) +
                    presentDurationData?.aggregations?.comments_datewise_breakdown?.buckets?.reduce((acc, val) => acc + val.data_stats?.sum, 0) +
                    presentDurationData?.aggregations?.shares_datewise_breakdown?.buckets?.reduce((acc, val) => acc + val.data_stats?.sum, 0);

                obj.previousDurationData =
                    previousDurationData?.aggregations?.likes_datewise_breakdown?.buckets?.reduce((acc, val) => acc + val.data_stats?.sum, 0) +
                    previousDurationData?.aggregations?.comments_datewise_breakdown?.buckets?.reduce((acc, val) => acc + val.data_stats?.sum, 0) +
                    presentDurationData?.aggregations?.shares_datewise_breakdown?.buckets?.reduce((acc, val) => acc + val.data_stats?.sum, 0);

                obj.avg_val = (obj.presentDurationData / presentDurationData?.hits?.total).toFixed(1);

                break;
            case "total-page-views":
                // obj.nodata = presentDurationData.data?.total[0]?.count == 0;
                obj.presentDurationData = presentDurationData.data?.total?.reduce((acc, val) => acc + val.count, 0);
                if (!obj.presentDurationData || !presentDurationData.data?.total) obj.nodata = true;
                // obj.previousDurationData = previousDurationData.data?.total[0]?.count;
                obj.previousDurationData = previousDurationData.data?.total?.reduce((acc, val) => acc + val.count, 0);
                break;

            case "total-posts":
            case "total-stories":
                obj.nodata = presentDurationData?.hits?.total == 0;
                obj.presentDurationData = presentDurationData?.hits?.total;
                obj.previousDurationData = previousDurationData?.hits?.total;
                break;

            case "total-posts-likes":
                obj.presentDurationData = presentDurationData?.aggregations?.likes_datewise_breakdown?.buckets?.reduce(
                    (acc, val) => acc + val.data_stats?.sum,
                    0,
                );
                obj.previousDurationData = previousDurationData?.aggregations?.likes_datewise_breakdown?.buckets?.reduce(
                    (acc, val) => acc + val.data_stats?.sum,
                    0,
                );
                // obj.avg_val = presentDurationData?.aggregations?.likes_datewise_breakdown?.buckets[0]?.data_stats?.avg?.toFixed(2);
                obj.avg_val = presentDurationData?.aggregations?.likes_datewise_breakdown?.buckets?.reduce(
                    (acc, val) => (acc + val.data_stats?.avg).toFixed(1),
                    0,
                );
                break;

            case "total-posts-comments":
                obj.presentDurationData = presentDurationData?.aggregations?.comments_datewise_breakdown?.buckets?.reduce(
                    (acc, val) => acc + val.data_stats?.sum,
                    0,
                );
                obj.previousDurationData = previousDurationData?.aggregations?.comments_datewise_breakdown?.buckets?.reduce(
                    (acc, val) => acc + val.data_stats?.sum,
                    0,
                );
                obj.avg_val = presentDurationData?.aggregations?.comments_datewise_breakdown?.buckets?.reduce(
                    (acc, val) => (acc + val.data_stats?.avg).toFixed(1),
                    0,
                );
                break;

            case "total-posts-impressions":
                obj.presentDurationData = presentDurationData?.aggregations?.impressions_datewise_breakdown?.buckets?.reduce(
                    (acc, val) => acc + val.data_stats?.sum,
                    0,
                );
                obj.previousDurationData = previousDurationData?.aggregations?.impressions_datewise_breakdown?.buckets?.reduce(
                    (acc, val) => acc + val.data_stats?.sum,
                    0,
                );
                obj.avg_val = presentDurationData?.aggregations?.impressions_datewise_breakdown?.buckets?.reduce(
                    (acc, val) => (acc + val.data_stats?.avg).toFixed(1),
                    0,
                );
                break;
            case "total-stories-engagements": {
                const aggsArr = [
                    "comments_datewise_breakdown",
                    "exits_datewise_breakdown",
                    "taps_backwards_datewise_breakdown",
                    "taps_forwards_datewise_breakdown",
                    "view_datewise_breakdown",
                ];
                let presentSum = 0;
                let prevSum = 0;

                aggsArr.forEach((aggsVal) => {
                    presentSum += presentDurationData?.aggregations?.[aggsVal]?.buckets?.reduce((acc, val) => acc + val.data_stats.sum, 0);
                    prevSum += previousDurationData?.aggregations?.[aggsVal]?.buckets?.reduce((acc, val) => acc + val.data_stats.sum, 0);
                });

                obj.presentDurationData = presentSum;
                obj.previousDurationData = prevSum;
                obj.avg_val = (obj.presentDurationData / presentDurationData?.hits?.total).toFixed(1);
                break;
            }
            default:
                break;
        }

        // if (obj.presentDurationData === 0) obj.nodata = true;
        if ((obj.presentDurationData && !(obj.presentDurationData > 0)) || obj.presentDurationData === 0) obj.nodata = true;

        if (!obj.nodata) {
            if (obj.previousDurationData !== 0)
                obj.percentage_change = +(((obj.presentDurationData - obj.previousDurationData) / obj.previousDurationData) * 100).toFixed(2);
        }
        return obj;
    }

    // not using this anymore RIP--14/09/22
    // if (chart_name === "total_engagement") {
    //     let eng1 = resp_data.find((r) => r.name === "eng1");
    //     let eng2 = resp_data.find((r) => r.name === "eng2");

    //     let obj = {
    //         eng1: null,
    //         eng2: null,
    //         nodata: false,
    //         avg_eng: null,
    //         percentage_change: null,
    //         durationGap: +data.durationGap.toFixed(0),
    //     };

    //     obj.nodata = eng1.data?.hits.total == 0;

    //     obj.eng1 =
    //         eng1.data?.aggregations?.likes_datewise_breakdown?.buckets?.reduce((acc, val) => acc + val.data_stats.sum, 0) +
    //         eng1.data?.aggregations?.comments_datewise_breakdown?.buckets?.reduce((acc, val) => acc + val.data_stats.sum, 0);
    //     obj.eng2 =
    //         eng2.data?.aggregations?.likes_datewise_breakdown?.buckets?.reduce((acc, val) => acc + val.data_stats.sum, 0) +
    //         eng2.data?.aggregations?.comments_datewise_breakdown?.buckets?.reduce((acc, val) => acc + val.data_stats.sum, 0);

    //     if ((obj.eng1 && !(obj.eng1 > 0)) || obj.eng1 === 0 || (obj.eng1 === 0 && obj.eng1 === 0)) obj.nodata = true;

    //     if (!obj.nodata) {
    //         obj.avg_eng = +(obj.eng1 / eng1.data?.hits.total).toFixed(2);
    //         if (obj.eng2 !== 0) obj.percentage_change = +(((obj.eng1 - obj.eng2) / obj.eng2) * 100).toFixed(2);
    //     }

    //     return obj;
    // }

    return resp_data;
}

export const sortPageList = (allPages = []) => {
    return (allPages = allPages.sort((a, b) => -1 * moment(a.updated_at) - moment(b.updated_at)));
};
export const sortInstaPages = (allPages = []) => {
    let active = allPages
        .filter((page) => page.status === "Active")
        .sort((a, b) => (a.account_name > b.account_name ? 1 : b.account_name > a.account_name ? -1 : 0));
    let inactive = allPages
        .filter((page) => page.status === "Inactive")
        .sort((a, b) => (a.account_name > b.account_name ? 1 : b.account_name > a.account_name ? -1 : 0));
    let expired = allPages
        .filter((page) => page.status === "Expired")
        .sort((a, b) => (a.account_name > b.account_name ? 1 : b.account_name > a.account_name ? -1 : 0));
    return [...active, ...inactive, ...expired];
};

export function formatTkData(data) {
    const chart_name = data?.chart_name;
    const resp_data = data?.response;
    // const isAverage = data?.isAverage;
    // const durationPeriod = +data?.durationGap?.toFixed(0) + 1;

    if (Object.keys(resp_data).length === 0) {
        return resp_data;
    }
    if (chart_name === "tiktok_page_follower_change" || chart_name === "linkedin_page_follower_change") {
        let data = resp_data?.follower_growth_overtime || [];
        let lineChartData = data.map((ele) => {
            // return { x: +moment(ele.key_as_string).format("x"), y: ele.count };
            return { x: +moment(ele.data_at).format("x"), y: ele.total };
        });
        return { lineChartData: lineChartData };
    }

    if (chart_name === "TKRecentPosts" || chart_name === "LKRecentPosts") {
        let recentPosts = [];
        let data;
        data = resp_data.filter((item) => {
            // console.log("validte", item?._source);
            return item?._source?.post?.post_subtype !== "ads";
        });
        let tz = JSON.parse(localStorage.company).user_timezone_name;
        data?.forEach((item) => {
            let image_url = "https://2020assets.s3.amazonaws.com/images/" + item?._source?.post?.media[0].folder + "/" + item?._source?.post?.media[0].name;
            let profile_pic =
                "https://2020assets.s3.amazonaws.com/images/" + item?._source?.post_author?.media[0].folder + "/" + item?._source?.post_author?.media[0].name;
            let totalEngagement =
                item?._source.post?.engagement_values?.like_count +
                item?._source.post?.engagement_values?.comment_count +
                item?._source.post?.engagement_values?.share_count;

            // + item?._source.post?.engagement_values?.share_count +
            // item?._source.post?.engagement_values?.view_count;
            if (item) {
                recentPosts.push({
                    gender: item?._source?.post_author?.gender,
                    profile_pic: profile_pic,
                    username: item?._source?.handlers[0].value,
                    post_type: item?._source?.post?.media[0].type,
                    image_url: image_url,
                    content: item?._source?.post?.content,
                    title: item?._source?.post?.title,
                    post_url: item?._source?.post?.url,
                    created_date: moment(item?._source?.post?.published_date).tz(tz).format("DD MMM YYYY"),
                    hover_date: moment(item?._source?.post?.published_date).tz(tz).format("LLLL z"),
                    engagement: item?._source?.post?.engagement_values,
                    impact: item?._source.impact_value,
                    totalEngagement: totalEngagement,
                });
            }
        });

        recentPosts = recentPosts.slice(0, 10);
        return recentPosts;
    }
    if (
        // TotalFollowers
        chart_name === "total_engagement" ||
        chart_name === "total-reach" ||
        chart_name === "total-page-views" ||
        chart_name === "total-posts" ||
        chart_name === "total-posts-likes" ||
        chart_name === "total-posts-comments" ||
        chart_name === "total-posts-impressions" ||
        chart_name === "total-share-mentions" ||
        chart_name === "total-posts-clicks" ||
        chart_name === "unique-posts-impressions" ||
        chart_name === "total-comment-mentions" ||
        chart_name === "total-posts-shares" ||
        chart_name === "lk-total-followers"
    ) {
        let { data: presentDurationData } = resp_data.find((r) => r.name === "presentDurationData");
        let { data: previousDurationData } = resp_data.find((r) => r.name === "previousDurationData");

        let obj = {
            presentDurationData: null,
            previousDurationData: null,
            nodata: false,
            percentage_change: null,
            durationGap: +data?.durationGap?.toFixed(0) + 1,
        };
        const aggsArr = ["comment-count-stats", "like-count-stats", "share-count-stats", "view-count-stats"];
        switch (chart_name) {
            case "total-reach":
                obj.nodata = presentDurationData?.hits?.total == 0;

                obj.presentDurationData = presentDurationData?.aggregations?.["total_estimated_reach"]?.value;
                obj.previousDurationData = previousDurationData?.aggregations?.["total_estimated_reach"]?.value;
                obj.avg_val = +(obj.presentDurationData / presentDurationData?.hits?.total).toFixed(1); // avg value based on duration gap
                break;
            case "lk-total-followers":
                // obj.nodata = presentDurationData?.hits?.total == 0;
                obj.presentDurationData = presentDurationData?.data?.follower_growth_overtime?.reduce((acc, val) => acc + val.total, 0);
                obj.previousDurationData = previousDurationData?.data?.follower_growth_overtime?.reduce((acc, val) => acc + val.total, 0);
                break;

            case "total_engagement": {
                obj.nodata = presentDurationData?.data?.engagement?.length == 0;
                obj.presentDurationData = presentDurationData?.data?.engagement?.reduce((acc, val) => acc + val.total, 0).toFixed(2);
                obj.previousDurationData = previousDurationData?.data?.engagement?.reduce((acc, val) => acc + val.total, 0);

                obj.avg_val = +(obj.presentDurationData / presentDurationData?.hits?.total).toFixed(1);

                break;
            }

            case "total-posts":
                obj.nodata = presentDurationData?.hits?.total == 0;
                obj.presentDurationData = presentDurationData?.hits?.total;
                obj.previousDurationData = previousDurationData?.hits?.total;
                obj.avg_val = +(obj.presentDurationData / presentDurationData?.hits?.total).toFixed(1);
                break;

            case "total-posts-likes":
                // console.log("presentDurationData", resp_data);
                obj.nodata = presentDurationData?.data?.likeCount?.length == 0;
                obj.presentDurationData = presentDurationData?.data?.likeCount?.reduce((acc, val) => acc + val.total, 0);
                obj.previousDurationData = previousDurationData?.data?.likeCount?.reduce((acc, val) => acc + val.total, 0);

                break;

            case "total-posts-comments":
                obj.nodata = presentDurationData?.data?.commentCount?.length == 0;
                obj.presentDurationData = presentDurationData?.data?.commentCount?.reduce((acc, val) => acc + val.total, 0);
                obj.previousDurationData = previousDurationData?.data?.commentCount?.reduce((acc, val) => acc + val.total, 0);

                break;
            case "total-posts-impressions":
                obj.nodata = presentDurationData?.data?.impressionCount?.length == 0;
                obj.presentDurationData = presentDurationData?.data?.impressionCount?.reduce((acc, val) => acc + val.total, 0);
                obj.previousDurationData = previousDurationData?.data?.impressionCount?.reduce((acc, val) => acc + val.total, 0);

                break;

            case "total-posts-shares":
                obj.nodata = presentDurationData?.data?.shareCount?.length == 0;
                obj.presentDurationData = presentDurationData?.data?.shareCount?.reduce((acc, val) => acc + val.total, 0);
                obj.previousDurationData = previousDurationData?.data?.shareCount?.reduce((acc, val) => acc + val.total, 0);

                break;

            case "total-comment-mentions":
                obj.nodata = presentDurationData?.data?.commentMentionsCount?.length == 0;
                obj.presentDurationData = presentDurationData?.data?.commentMentionsCount?.reduce((acc, val) => acc + val.total, 0);
                obj.previousDurationData = previousDurationData?.data?.commentMentionsCount?.reduce((acc, val) => acc + val.total, 0);

                break;

            case "unique-posts-impressions":
                obj.nodata = presentDurationData?.data?.uniqueImpressionsCount?.length == 0;

                obj.presentDurationData = presentDurationData?.data?.uniqueImpressionsCount?.reduce((acc, val) => acc + val.total, 0);
                obj.previousDurationData = previousDurationData?.data?.uniqueImpressionsCount?.reduce((acc, val) => acc + val.total, 0);
                break;
            case "total-posts-clicks":
                obj.nodata = presentDurationData?.data?.clickCount?.length == 0;

                obj.presentDurationData = presentDurationData?.data?.clickCount?.reduce((acc, val) => acc + val.total, 0);
                obj.previousDurationData = previousDurationData?.data?.clickCount?.reduce((acc, val) => acc + val.total, 0);
                break;
            case "total-share-mentions":
                obj.nodata = presentDurationData?.data?.shareMentionsCount?.length == 0;
                obj.presentDurationData = presentDurationData?.data?.shareMentionsCount?.reduce((acc, val) => acc + val.total, 0);
                obj.previousDurationData = previousDurationData?.data?.shareMentionsCount?.reduce((acc, val) => acc + val.total, 0);
                break;

            default:
                break;
        }

        if ((obj.presentDurationData && !(obj.presentDurationData > 0)) || obj.presentDurationData === 0) obj.nodata = true;

        if (!obj.nodata) {
            if (obj.previousDurationData !== 0)
                obj.percentage_change = +(((obj.presentDurationData - obj.previousDurationData) / obj.previousDurationData) * 100).toFixed(2);
        }
        return obj;
    }
    if (chart_name === "followersCountByFacets") {
        // Object.entries(resp_data.followers_by_facet).forEach(([key, value]) => {
        //     value.forEach((obj) => {
        //         console.log("asdfgeg", data[key]);
        //         // data[key][obj.facet_value] = organic_follower_count + paid_follower_count;
        //         let facetVal =obj.facet_value
        //         data[key]={

        //             obj[facetVal]: organic_follower_count + paid_follower_count
        //         }

        //     });
        // });
        // resp_data?.

        const obj = {
            followerCountsByCountry: resp_data.followers_by_facet?.followerCountsByCountry?.reduce(
                (obj, { facet_value, organic_follower_count, paid_follower_count }) => {
                    obj[facet_value] = organic_follower_count + paid_follower_count;
                    return obj;
                },
                {},
            ),
            followerCountsByFunction: resp_data.followers_by_facet?.followerCountsByFunction?.reduce(
                (obj, { facet_value, organic_follower_count, paid_follower_count }) => {
                    obj[facet_value] = organic_follower_count + paid_follower_count;
                    return obj;
                },
                {},
            ),
            followerCountsByIndustry: resp_data.followers_by_facet?.followerCountsByIndustry?.reduce(
                (obj, { facet_value, organic_follower_count, paid_follower_count }) => {
                    obj[facet_value] = organic_follower_count + paid_follower_count;
                    return obj;
                },
                {},
            ),
            followerCountsByRegion: resp_data.followers_by_facet?.followerCountsByRegion?.reduce(
                (obj, { facet_value, organic_follower_count, paid_follower_count }) => {
                    obj[facet_value] = organic_follower_count + paid_follower_count;
                    return obj;
                },
                {},
            ),
            followerCountsBySeniority: resp_data.followers_by_facet?.followerCountsBySeniority?.reduce(
                (obj, { facet_value, organic_follower_count, paid_follower_count }) => {
                    obj[facet_value] = organic_follower_count + paid_follower_count;
                    return obj;
                },
                {},
            ),
            followerCountsByStaffCountRang: resp_data.followers_by_facet?.followerCountsByStaffCountRang?.reduce(
                (obj, { facet_value, organic_follower_count, paid_follower_count }) => {
                    obj[facet_value] = organic_follower_count + paid_follower_count;
                    return obj;
                },
                {},
            ),
        };

        if (obj.followerCountsByStaffCountRang) {
            if (obj.followerCountsByStaffCountRang?.SIZE_1 || obj.followerCountsByStaffCountRang?.SIZE_2_TO_10) {
                obj.followerCountsByStaffCountRang["SIZE_1_TO_10"] =
                    obj.followerCountsByStaffCountRang?.SIZE_1 + obj.followerCountsByStaffCountRang?.SIZE_2_TO_10;
                delete obj.followerCountsByStaffCountRang?.SIZE_1;
                delete obj.followerCountsByStaffCountRang?.SIZE_2_TO_10;
            }
        }
        return obj;
    }
    if (chart_name === "audience_metrics_by_country") {
        let barChartData = [];
        let pieChartData = [];
        let LocationWithData = [];
        // let countryData = resp_data || {};
        let countryData = resp_data?.aggregations?.["country-wise-breakup"]?.buckets || [];

        const masterLocationList = countryColorList;

        let LocationKeys = [];
        let hashMap = [];
        let locationHashMap = {};

        countryData.forEach((ele) => {
            hashMap.push({ name: ele.key, count: ele.doc_count });
            LocationKeys.push(ele.key);
            locationHashMap[ele.key] = ele.key;
        });

        // for (const key in countryData) {
        //     console.log("savdsavas", hashMap, key, countryData);
        //     // let count = 0;
        //     // countryData[key].forEach((ele) => {
        //     //     count += ele.count;
        //     // });
        //     hashMap.push({ name: key, count: doc_count });
        //     LocationKeys.push(key);
        //     console.log("savdsavas end", hashMap, key);
        // }

        // let locationHashMap = {};
        // let locationHashMap = LocationKeys;
        // LocationKeys.forEach((short_name) => {
        //     let country = masterLocationList.find((ele) => ele.code.toLowerCase() == short_name);
        //     if (country) {
        //         locationHashMap[short_name] = country.country;
        //     }
        // });

        let sortedHashMap = hashMap.sort((a, b) => {
            if (a.count > b.count) {
                return -1;
            } else return 1;
        });

        let totalCount = sortedHashMap.reduce((acc, curr) => {
            return acc + curr.count;
        }, 0);

        sortedHashMap.forEach((ele, ind) => {
            if (ind < 9) {
                let obj = {};
                // obj["name"] = locationHashMap[ele.name];
                obj["name"] = ele.name;
                obj["data"] = [];
                let dataObj = {};
                // dataObj["name"] = locationHashMap[ele.name];
                dataObj["name"] = ele.name;
                dataObj["y"] = ele.count;
                dataObj["total"] = totalCount;
                obj["data"].push(dataObj);
                barChartData.push(obj);
                // pieChartData.push({ name: locationHashMap[ele.name], y: ele.count });
                pieChartData.push({ name: ele.name, y: ele.count });
                // LocationWithData.push(locationHashMap[ele.name]);
                LocationWithData.push(ele.name);
            }
        });

        if (sortedHashMap.length > 9) {
            let count = 0;
            sortedHashMap.forEach((ele, ind) => {
                if (ind > 8) {
                    count += ele.count;
                }
            });
            if (count > 0) {
                let obj = {};
                obj["name"] = "Others";
                obj["data"] = [];
                let dataObj = {};
                dataObj["name"] = "Others";
                dataObj["y"] = count;
                dataObj["total"] = totalCount;
                obj["data"].push(dataObj);
                pieChartData.push({ name: "Others", y: count });
                barChartData.push(obj);
                LocationWithData.push("Others");
            }
        }
        barChartData = barChartData.sort((a, b) => {
            if (a.data[0].y > b.data[0].y) {
                return 1;
            }
            if (a.data[0].y < b.data[0].y) {
                return -1;
            } else return 0;
        });

        return {
            barChartData: barChartData,
            pieChartData: pieChartData,
            LocationWithData: LocationWithData,
            downLoadData: sortedHashMap,
            allLocation: locationHashMap,
        };
    }
    if (chart_name === "tiktok_posts_overtime" || chart_name === "linkedin_posts_overtime") {
        let data = { nodata: resp_data.hits.total === 0, lineChartData: [] };
        let total = 0;
        let tz = JSON.parse(localStorage.company).user_timezone_name;

        data.lineChartData = resp_data.aggregations.conversation_over_time.buckets.map((d) => {
            total += d.doc_count;
            let date = +moment(d.key).tz(tz).format("x");
            return [date, d.doc_count];
        });

        data.nodata = total === 0;

        return data;
    }
    if (chart_name === "tiktok_post_likes") {
        let obj = {
            nodata: resp_data.hits.total === 0,
            likes_agg: [],
            avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let total = 0;
        resp_data.aggregations?.reactions_datewise_breakdown?.buckets.forEach((likes) => {
            let d = +moment(likes.key).tz(tz).format("x");
            obj.likes_agg.push([d, likes.like_count.sum || 0]);

            total += likes.like_count.sum;
        });

        let totallength = resp_data.hits.total || 1;
        obj.avg_value = +(total / totallength).toFixed(2);

        return obj;
    }
    if (chart_name === "tiktok_post_comments") {
        let obj = {
            nodata: resp_data.hits.total === 0,
            comments_agg: [],
            avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let total = 0;

        resp_data.aggregations?.reactions_datewise_breakdown?.buckets.forEach((comments) => {
            let d = +moment(comments.key).tz(tz).format("x");
            obj.comments_agg.push([d, comments.comment_count.sum || 0]);
            total += comments.comment_count.sum;
        });

        let totallength = resp_data.hits.total || 1;
        obj.avg_value = +(total / totallength).toFixed(2);

        return obj;
    }
    if (chart_name === "tiktok_post_impressions") {
        let obj = {
            nodata: resp_data.hits.total === 0,
            impression_agg: [],
            avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let total = 0;
        resp_data.aggregations.reactions_datewise_breakdown.buckets.forEach((views) => {
            let d = +moment(views.key).tz(tz).format("x");
            obj.impression_agg.push([d, views.view_count.sum || 0]);
            total += views.view_count.sum;
        });
        let totallength = resp_data.hits.total || 1;
        obj.avg_value = +(total / totallength).toFixed(2);
        return obj;
    }
    if (chart_name === "linkedin_post_impressions") {
        let obj = {
            nodata: resp_data.impressionCount?.length === 0,
            impression_agg: [],
            // avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let total = 0;
        resp_data.impressionCount?.forEach((views) => {
            let d = +moment(views.data_at?.split(" ")[0]).tz(tz).format("x");
            obj.impression_agg.push([d, views.total || 0]);
            total += views.total;
        });

        return obj;
    }
    if (chart_name === "tiktok_post_reach" || chart_name === "linkedin_post_reach") {
        // console.log(resp_data);

        let obj = {
            nodata: resp_data.hits.total === 0,
            views_agg: [],
            avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;
        let total = 0;

        resp_data.aggregations.conversation_over_time_estimated_reach.buckets.forEach((reach) => {
            let d = +moment(reach.key).tz(tz).format("x");
            obj.views_agg.push([d, reach.stats.sum || 0]);
            total += reach.stats.sum;
        });

        let totallength = resp_data.hits.total || 1;
        obj.avg_value = +(total / totallength).toFixed(2);

        return obj;
    }
    if (chart_name === "engagement_over_time") {
        let obj = {
            nodata: resp_data.engagement?.length === 0,
            total_agg: [],
            // avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;
        // let total = 0;
        resp_data.engagement?.forEach((views) => {
            let d = +moment(views.data_at?.split(" ")[0]).tz(tz).format("x");

            obj.total_agg.push([d, +views.total?.toFixed(4) || 0]);
            // total += views.total;
        });

        return obj;
    }
    if (chart_name === "linkedin_unique_post_impressions") {
        let obj = {
            nodata: resp_data.uniqueImpressionsCount?.length === 0,
            impression_agg: [],
            // avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;

        resp_data.uniqueImpressionsCount?.forEach((views) => {
            let d = +moment(views.data_at?.split(" ")[0]).tz(tz).format("x");
            obj.impression_agg.push([d, views.total || 0]);
        });

        return obj;
    }

    if (chart_name === "linkedin_post_shares") {
        let obj = {
            nodata: resp_data.shareCount?.length === 0,
            shareCount: [],
            // avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;

        resp_data.shareCount?.forEach((views) => {
            let d = +moment(views.data_at?.split(" ")[0]).tz(tz).format("x");
            obj.shareCount.push([d, views.total || 0]);
        });
        return obj;
    }

    if (chart_name === "linkedin_post_share_mentions") {
        let obj = {
            nodata: resp_data.shareMentionsCount?.length === 0,
            shareMentionsCount: [],
            // avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;

        resp_data.shareMentionsCount?.forEach((views) => {
            let d = +moment(views.data_at?.split(" ")[0]).tz(tz).format("x");
            obj.shareMentionsCount.push([d, views.total || 0]);
        });
        return obj;
    }

    if (chart_name === "linkedin_post_clicks") {
        let obj = {
            nodata: resp_data.clickCount?.length === 0,
            clickCount: [],
            // avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;

        resp_data.clickCount?.forEach((views) => {
            let d = +moment(views.data_at?.split(" ")[0]).tz(tz).format("x");
            obj.clickCount.push([d, views.total || 0]);
        });
        return obj;
    }

    if (chart_name === "linkedin_comment_mentions") {
        let obj = {
            nodata: resp_data.commentMentionsCount?.length === 0,
            commentMentionsCount: [],
            // avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;

        resp_data.commentMentionsCount?.forEach((views) => {
            let d = +moment(views.data_at?.split(" ")[0]).tz(tz).format("x");
            obj.commentMentionsCount.push([d, views.total || 0]);
        });
        return obj;
    }

    if (chart_name === "linkedin_post_likes") {
        let obj = {
            nodata: resp_data.likeCount?.length === 0,
            likes_agg: [],
            // avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;

        resp_data.likeCount?.forEach((views) => {
            let d = +moment(views.data_at?.split(" ")[0]).tz(tz).format("x");
            obj.likes_agg.push([d, views.total || 0]);
        });
        return obj;
    }

    if (chart_name === "linkedin_post_comments") {
        let obj = {
            nodata: resp_data.commentCount?.length === 0,
            comments_agg: [],
            // avg_value: 0,
        };

        let tz = JSON.parse(localStorage.company).user_timezone_name;

        resp_data.commentCount?.forEach((views) => {
            let d = +moment(views.data_at?.split(" ")[0]).tz(tz).format("x");
            obj.comments_agg.push([d, views.total || 0]);
        });
        return obj;
    }
}

export const getMetricsValue = (chartName) => {
    const metrics = {
        "unique-posts-impressions": "uniqueImpressionsCount",
        "total-posts-shares": "shareCount",
        "total-share-mentions": "shareMentionsCount",
        total_engagement: "engagement",
        "total-posts-clicks": "clickCount",
        "total-posts-impressions": "impressionCount",
        "total-comment-mentions": "commentMentionsCount",
        "total-posts-comments": "commentCount",
        "total-posts-likes": "likeCount",
    };
    return metrics[chartName];
};
export const getInterval = (data) => {
    let interval = null;
    switch (data) {
        case "day":
        case "daily":
            interval = "daily";
            break;

        case "week":
        case "weekly":
            interval = "weekly";
            break;
        case "month":
        case "monthly":
            interval = "monthly";
            break;

        case "year":
        case "yearly":
            interval = "yearly";
            break;

        default:
            interval = "daily";
    }
    return interval;
};
export const getWidgetName = (widgetName) => {
    const defaulWidgetNames = {
        "Tweets by Duration": "Tweets",
        "Total Comment Mentions": "Comment Mentions",
        "Total Repost Mention Count": "Repost Mentions",
        // "Total Post Shares": "Post Shares",
        "Total Post Clicks": "Post Clicks",
        "Unique Post Impressions": "Unique Impressions",
        "Total Post Engagement Rate": "Engagement Rate",
        "Average View Duration": "Minutes",
        "Total Engagement Rate": "Engagement Rate",
    };
    if (defaulWidgetNames[widgetName]) {
        return defaulWidgetNames[widgetName];
    }
    return widgetName?.split(" ").pop() || "name";
};
